<template>
  <b-modal id="modalEditSummary"
    centered size="lg"
    title="Editar manifiesto"
    hide-footer
    @close="onCloseModal"
    no-close-on-esc
    no-close-on-backdrop>
      <div class="m-0">
        <div class="my-1">
          <b-alert
            class="p-1 custom-alert col-md-6"
            variant="warning"
            show>
              <div class="m-0">
                <feather-icon size="20" class="mr-50" icon="InfoIcon"/>
                <span>
                  Ingrese solo los datos que desea modificar
                </span>
              </div>
          </b-alert>
        </div>

        <div>
          <form-render :fields="fields" :form.sync="form" @send="editSummary" ref="formRenderEditSummary" containerButtonsClass="col-sm-12">
            <template #buttons>
              <div class="d-flex justify-content-end align-items-center">
                <b-button
                  class="m-1"
                  variant="warning"
                  @click="ok"
                  :disabled="loading.editSummary">
                  <span class="mb-1">Guardar cambios</span>
                  <b-spinner v-if="loading.editSummary" class="ml-1" small/>
                </b-button>
              </div>
            </template>
          </form-render>
        </div>

      </div>
  </b-modal>
</template>

<script>
import BaseServices from '@/store/services/index'
import {endpoint} from './../endpoints.service.js'
import { tooltip } from 'leaflet'
export default {
  data() {
    return {
      baseService: new BaseServices(this),
      form: {},
      fields: [],
      optionCheckboxs: [
        { 'id': 1, 'text': 'Eliminar todos los archivos de confirmación' }
      ],
      loading: {
        editSummary: false
      },
      disabled: {
        editSummary: false
      },
      statusOptions: [
        { id: 1, text: '1 - Abierto' },
        { id: 2, text: '2 - Cerrado' },
        { id: 3, text: '3 - Confirmado' }
      ],
      activeOptions: [
        { id: 0, text: 'false', code: false },
        { id: 1, text: 'true', code: true }
      ],
      optionsDelete: [
        { id: 1, text: 'Eliminar', code: true },
        { id: 2, text: 'Activar', code: false }
      ]
    }
  },
  mounted () {
    this.setInitialData()
  },
  computed: {
    user() {
      return this.$session.get('cas_user')
    },
    source() {
      return this.sourceList || this.$route.query.source || 'delivery'
    },
    isSourceDelivery() {
      return this.source === 'delivery'
    },
    endpointValues() {
      return endpoint[this.source]
    }
  },
  methods: {
    setInitialData() {
      this.fields = [
        {
          fieldType: 'FieldInput',
          name: 'summary_id',
          type: 'number',
          label: 'ID Manifiesto',
          validation: 'required',
          containerClass: 'col-sm-12 container-info'
        },
        {
          fieldType: 'FieldSelect',
          name: 'delivery_label_print_status_id',
          label: 'delivery_label_print_status_id',
          containerClass: 'col-sm-12 container-info',
          options: this.statusOptions
        },
        {
          fieldType: 'FieldSelect',
          name: 'active',
          label: 'active',
          containerClass: 'col-sm-12 container-info',
          options: this.activeOptions
        },
        {
          fieldType: 'FieldInput',
          name: 'deliveries',
          label: 'deliveries',
          containerClass: 'col-sm-12 container-info',
          description: 'Nota: Ingresar todos los envíos que deben quedar en el campo con el formato de array. Ejemplo: [123456,123457, 123458].'
        },
        {
          fieldType: 'FieldInput',
          name: 'label_url',
          label: 'label_url',
          containerClass: 'col-sm-12 container-info'
        },
        {
          fieldType: 'FieldInput',
          name: 'summary_url',
          label: 'summary_url',
          containerClass: 'col-sm-12 container-info'
        },
        {
          fieldType: 'FieldRadio',
          name: 'deleted_at',
          label: 'Eliminar o activar manifiesto',
          containerClass: 'col-sm-12 col-md-12 col-lg-12 container-info',
          align: 'h',
          options: this.optionsDelete,
          tooltip: { text: 'Si selecciona la opción eliminar se seteara un valor "YYYY-MM-DD HH:MM:SS" en el campo deleted_at del manifiesto' }
        },
        {
          fieldType: 'FieldCheckbox',
          name: 'voucher',
          label: 'voucher',
          containerClass: 'col-sm-12 col-md-12 col-lg-12 container-info',
          align: 'h',
          options: this.optionCheckboxs
        }
      ]
    },
    formatPayloadEditSummary (form) {
      const payload = {
        summary_id: Number(form.summary_id)
      }
      if (form.delivery_label_print_status_id) payload['delivery_label_print_status_id'] = form.delivery_label_print_status_id.id
      if (form.active) payload['active'] = form.active.code
      if (form.deliveries) payload['deliveries'] = form.deliveries
      if (form.label_url) payload['label_url'] = form.label_url
      if (form.summary_url) payload['summary_url'] = form.summary_url
      if (form.deleted_at) payload['deleted'] = form.deleted_at.code
      if (form.voucher) payload['delete_voucher'] = true

      return payload
    },
    ok (e) {
      e.preventDefault()
      this.$refs.formRenderEditSummary.checkForm()
    },
    editSummary() {
      this.loading.editSummary = true
      const queryParams = this.formatPayloadEditSummary(this.form)

      this.baseService.callService(this.endpointValues.editSummary, queryParams, { idSummary: this.form.summary_id }, { fullResponseError: true })
        .then(resp => {
          this.$emit('updateListSummaries')
          this.$newSuccess('¡Manifiesto editado con exito!', 'Se han guardado los cambios correctamente.', 'large')
          this.$bvModal.hide('modalEditSummary')
          this.onCloseModal()
        })
        .catch(err => {
          this.$alert(err.message)
        })
        .finally(() => {
          this.loading.editSummary = false
        })
    },
    onCloseModal() {
      this.loading.editSummary = false
      this.form = {}
    }
  }
}
</script>

<style lang="scss">
  .custom-alert {
    border: 1px solid #f18805;
  }
</style>